import React, { cloneElement, memo, useState } from "react";
import filter from "../assets/images/svg/filter.svg";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Popover,
  Typography,
  TextField,
  Slider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AmountRangeFilter from "./filters/AmountRangeFilter";
const dayjs = require("dayjs");

// Custom styled Slider
const CustomSlider = styled(Slider)({
  "& .MuiSlider-valueLabel": {
    backgroundColor: "#673C8E",
    color: "#fff",
  },
  "& .MuiSlider-markLabel": {
    fontSize: "8px",
  },
});

const Filter = ({
  url,
  config,
  onFilterData,
  onResetFilters,
  type,
  setIsSorting,
  filtrationData,
  setSortedData,
  size = "small",
  backgroundColor,
  renderButton,
  CustomDate,
  rangeFilter,
  rangeFilterCategory,
  dateCategory,
  filterOptionsColor,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({});

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Multi-select filter change handler
  const handleFilterChange = (key, optionValue) => {
    setSelectedFilters((prev) => {
      const prevValues = prev[key] || [];

      let newValues;
      if (prevValues.includes(optionValue)) {
        // Uncheck
        newValues = prevValues.filter((val) => val !== optionValue);
      } else {
        // Check
        newValues = [...prevValues, optionValue];
      }

      const newFilters = {
        ...prev,
        // ...filtrationData,
        [key]: newValues.length > 0 ? newValues : undefined, // Remove key if empty
      };
      return newFilters;
    });
  };

  const handleResetClick = () => {
    setSelectedFilters({});
    onResetFilters();
  };

  const isFilterApplied = Object.values(selectedFilters).some(
    (value) =>
      (Array.isArray(value) && value.length > 0) ||
      (typeof value === "string" && value !== "") ||
      (value !== null && value !== undefined)
  );

  const handleApply = () => {
    setIsSorting?.(true);
    onFilterData(selectedFilters);
    setSortedData?.([]);
    handleClose();
  };

  const open = Boolean(anchorEl);

  return (
    <>
      {renderButton ? (
        cloneElement(renderButton(), { onClick: handleClick })
      ) : (
        <Button
          variant={
            type === "clients" || type === "drivers" || type === "reviewFilter"
              ? "outlined"
              : "contained"
          }
          size={size}
          onClick={handleClick}
          sx={{
            textTransform: "capitalize",
            backgroundColor: "#683C8C",
            color: "#FFFFFF",
            borderColor: "#683C8C",
            "&:hover": {
              backgroundColor: "#683C8C",
              color: "#FFFFFF",
              borderColor: "#683C8C",
            },
          }}
          startIcon={<img style={{ width: "20px" }} src={filter} alt="Logo" />}
          endIcon={
            type === "clients" ||
            type === "drivers" ||
            type === "reviewFilter" ? (
              <ArrowDropDownIcon />
            ) : (
              ""
            )
          }
        >
          Filter
        </Button>
      )}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{ marginTop: "15px" }}
      >
        <div
          style={{
            maxWidth: "250px",
            padding: "12px",
            height: "auto",
            backgroundColor,
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Typography
                sx={{
                  color: "rgba(23, 26, 31, 1)",
                  fontSize: "13px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                Filters
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign="right">
              <Typography
                onClick={handleResetClick}
                sx={{
                  color: "rgba(23, 26, 31, 1)",
                  fontSize: "13px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                Reset
              </Typography>
            </Grid>

            {/* =========================== DISPLAY CHECKBOX FILTERS ================================ */}
            {config.filters.map((filterCategory, index) => (
              <Grid item xs={12} key={index} mt={type === "orders" ? 2 : 0}>
                {filterCategory.category && (
                  <Typography
                    sx={{
                      color: "rgba(23, 26, 31, 1)",
                      fontSize: "10px",
                      fontWeight: 700,
                    }}
                  >
                    {filterCategory.category}
                  </Typography>
                )}
                <FormGroup>
                  {filterCategory.options.map((option, idx) => (
                    <FormControlLabel
                      key={idx}
                      sx={{ fontSize: "10px" }}
                      control={
                        <Checkbox
                          sx={{
                            color: "#683C8C",
                            "&.Mui-checked": {
                              color: "#683C8C",
                            },
                          }}
                          checked={
                            Array.isArray(
                              selectedFilters[filterCategory.key]
                            ) &&
                            selectedFilters[filterCategory.key].includes(
                              option.value
                            )
                          }
                          onChange={() =>
                            handleFilterChange(filterCategory.key, option.value)
                          }
                        />
                      }
                      label={
                        <Typography
                          sx={{
                            fontSize: "10px",
                            color: filterOptionsColor ?? "inherit",
                          }}
                        >
                          {option.label}
                        </Typography>
                      }
                    />
                  ))}
                </FormGroup>
              </Grid>
            ))}
            {/* =========================== DISPLAY CHECKBOX FILTERS ================================ */}

            {/* AMOUNT RANGE FILTER */}
            <AmountRangeFilter
              rangeFilter={rangeFilter}
              rangeFilterCategory={rangeFilterCategory}
              type={type}
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
            />

            {/* ======================================== DATE RANGE FILTER ======================================== */}
            {CustomDate ? (
              <CustomDate
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
              />
            ) : (
              <Grid item xs={12}>
                <Typography
                  sx={{
                    color: "rgba(23, 26, 31, 1)",
                    fontSize: "10px",
                    mb: 1,
                    fontWeight: 700,
                  }}
                >
                  {dateCategory
                    ? dateCategory
                    : type === "orders" ||
                      type === "clientStatement" ||
                      type === "executiveStatement" ||
                      type === "reviewFilter" ||
                      type === "chats" ||
                      type === "tutorials"
                    ? "Date Range"
                    : type === "regularOffers"
                    ? "Date"
                    : type === "driverStatement"
                    ? "Payout Date Range"
                    : type === "accepted-category"
                    ? "Filter with Created Date"
                    : type === "helpOffers"
                    ? "Created Date"
                    : "Filter with Join Date"}
                </Typography>

                {/* FROM DATE */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Typography
                    sx={{
                      color: "rgba(23, 26, 31, 1)",
                      fontSize: "12px",
                      mb: 1,
                    }}
                  >
                    {type === "regularOffers" ? "Start" : "From"}:
                  </Typography>
                  <Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        format="DD MMM YYYY"
                        maxDate={
                          selectedFilters?.to
                            ? dayjs(selectedFilters?.to)
                            : null
                        }
                        slotProps={{
                          textField: {
                            placeholder: "DD MMM YYYY",
                          },
                        }}
                        value={
                          selectedFilters?.from
                            ? dayjs(selectedFilters.from)
                            : null
                        }
                        onChange={(newValue) => {
                          // const formattedDate =
                          //   dayjs(newValue).format("YYYY-MM-DD");
                          setSelectedFilters((prev) => ({
                            ...prev,
                            from: new Date(
                              new Date(newValue).setHours(0, 0, 0, 0)
                            ).toISOString(),
                          }));
                        }}
                        sx={{
                          "& .MuiInputBase-input": {
                            padding: "7px",
                            borderRadius: "14px",
                            fontSize: "14px",
                            border: "none",
                          },
                          "& .css-1yq5fb3-MuiButtonBase-root-MuiIconButton-root":
                            {
                              color: "#673C8E",
                            },
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "14px",
                          },
                          "& .MuiOutlinedInput-root fieldset": {
                            border: "2px solid #673C8E",
                          },
                          "& .MuiOutlinedInput-root fieldset:hover": {
                            borderColor: "#673C8E",
                          },
                          "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                            borderColor: "#673C8E",
                          },
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>

                {/* TO DATE */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Typography
                    sx={{
                      color: "rgba(23, 26, 31, 1)",
                      fontSize: "12px",
                      mb: 1,
                    }}
                  >
                    {type === "regularOffers" ? "Expiry" : "To"}:
                  </Typography>
                  <Box sx={{ width: "80%", mt: 1 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        format="DD MMM YYYY"
                        minDate={
                          selectedFilters?.from
                            ? dayjs(selectedFilters?.from)
                            : null
                        }
                        slotProps={{
                          textField: {
                            placeholder: "DD MMM YYYY",
                          },
                        }}
                        value={
                          selectedFilters?.to ? dayjs(selectedFilters.to) : null
                        }
                        onChange={(newValue) => {
                          const formattedDate =
                            dayjs(newValue).format("YYYY-MM-DD");
                          setSelectedFilters((prev) => ({
                            ...prev,
                            to: new Date(
                              new Date(newValue).setHours(23, 59, 59, 999)
                            ).toISOString(),
                          }));
                        }}
                        sx={{
                          "& .MuiInputBase-input": {
                            padding: "7px",
                            borderRadius: "14px",
                            border: "none",
                            fontSize: "14px",
                          },
                          "& .css-1yq5fb3-MuiButtonBase-root-MuiIconButton-root":
                            {
                              color: "#673C8E",
                            },
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "14px",
                          },
                          "& .MuiOutlinedInput-root fieldset": {
                            border: "2px solid #673C8E",
                          },
                          "& .MuiOutlinedInput-root fieldset:hover": {
                            borderColor: "#673C8E",
                          },
                          "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                            borderColor: "#673C8E",
                          },
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
              </Grid>
            )}
            {/* ======================================== DATE RANGE FILTER ======================================== */}

            {/* Cancel and Apply Buttons */}
            <Grid item xs={6} sx={{ mb: 1, mt: 2 }}>
              <Button
                variant="outlined"
                size="small"
                fullWidth
                onClick={handleClose}
                sx={{
                  color: "#683C8C",
                  mr: 2,
                  borderColor: "#683C8C",
                  "&:hover": {
                    color: "#683C8C",
                    borderColor: "#683C8C",
                  },
                }}
              >
                Cancel
              </Button>
            </Grid>

            <Grid item xs={6} sx={{ textAlign: "right", mb: 1, mt: 2 }}>
              <Button
                variant="contained"
                size="small"
                fullWidth
                disabled={!isFilterApplied}
                onClick={handleApply}
                sx={{
                  backgroundColor: "#683C8C",
                  color: "#FFFFFF",
                  borderColor: "#683C8C",
                  "&:hover": {
                    backgroundColor: "#683C8C",
                    color: "#FFFFFF",
                    borderColor: "#683C8C",
                  },
                }}
              >
                Apply
              </Button>
            </Grid>
          </Grid>
        </div>
      </Popover>
    </>
  );
};

export default memo(Filter);
